module.exports = __webpack_public_path__ + "img/wonderpersian_tech_Normal_ua.19aa69ed.webp";